import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { EstreamProvider } from '@estream/sdk-browser/react';
import App from './App';
import './styles/global.css';

// Transport URLs
// HTTP fallback mode until #191 (WebTransport server) is deployed
// When #191 is complete: switch back to 'https://edge.estream.dev:4433'
const EDGE_URL = import.meta.env.VITE_EDGE_URL || 'https://edge.estream.dev';
const NETWORK = import.meta.env.VITE_NETWORK || 'alpha-devnet';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <EstreamProvider 
      config={{ 
        url: EDGE_URL,
        network: NETWORK,
        debug: import.meta.env.DEV,
        // Note: Dashboard hooks use HTTP polling until #191 (WebTransport) is deployed
        // See src/hooks/useHttpPolling.ts for fallback logic
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </EstreamProvider>
  </StrictMode>
);
